export const NEXWAY = 'Nexway';

export const SIDEBAR_WIDTH_WITH_SCROLL = 277;
export const SIDEBAR_WIDTH_WITH0UT_SCROLL = 260;
export const SIDEBAR_WIDTH_COLLAPSED = 60;

export const FAILED_EVENT = 'failed_event';
export const ERROR_ROW_CLASS = 'error-row-color';

export const apiReason = 'MyNexway';
export const FR_TERRITORIES = [
  'TF',
  'BL',
  'GP',
  'GF',
  'MF',
  'MQ',
  'YT',
  'NC',
  'PF',
  'RE',
  'PM',
  'WF',
];
